export const HANDLE_INPUT_CHANGE = 'HANDLE_INPUT_CHANGE';
export const HANDLE_INPUT_BLUR = 'HANDLE_INPUT_BLUR';
export const TOGGLE_AGREE_TERMS = 'TOGGLE_AGREE_TERMS';
export const UPDATE_SUBMIT_STATE = 'UPDATE_SUBMIT_STATE';

interface IInputState {
	isValid: boolean;
	value: string;
}

export interface IOnboardingState {
	agreeTerms: boolean;
	errorOnBlur: boolean;
	input: IInputState;
	submitted: boolean;
}

export interface IInputAction {
	payload: IInputState;
	type: typeof HANDLE_INPUT_CHANGE | typeof HANDLE_INPUT_BLUR;
}

export interface IToggleAction {
	type: typeof TOGGLE_AGREE_TERMS;
}

export interface ISubmitAction {
	submit: boolean;
	type: typeof UPDATE_SUBMIT_STATE;
}

export type OnboardingActionTypes =
	| IInputAction
	| IToggleAction
	| ISubmitAction;
